import type { ReactNode } from 'react';
import { OtpAuthGate } from '@lemontaigu/platform-ui';
import { supabase } from '../supabase.js';

/**
 * Personal-space gate (Q-D, amended M1 — ADR-0010 §2): e-mail → 6-digit code
 * typed in-app → session. Membership = the caller can read the
 * `staff_employees` roster (RLS: linked employees and operators only; the
 * auto-link trigger in migration 0015 attaches the auth user to their employee
 * row by e-mail on first sign-in).
 *
 * NOTE: column grants (migration 0016) — always SELECT explicit columns, never
 * '*', on staff_employees.
 *
 * Flow shared via @lemontaigu/platform-ui (ladder step 4, F8).
 */
async function isMember(): Promise<boolean> {
  const { data, error } = await supabase.from('staff_employees').select('id').limit(1);
  if (error) return false;
  return (data?.length ?? 0) > 0;
}

export function AuthGate({ children }: { children: ReactNode }) {
  return (
    <OtpAuthGate
      client={supabase}
      brand="Mon Compte"
      checkMembership={isMember}
      deniedMessage="Cette adresse e-mail n’est pas reconnue comme membre de l’équipe. Vérifiez que vous avez utilisé l’adresse communiquée à la direction, ou contactez-la."
    >
      {children}
    </OtpAuthGate>
  );
}
